import React, { memo, useCallback } from 'react';
import { Keyboard, TouchableOpacity, View } from 'react-native';
import Text from 'design-system/Text';
import Amount from 'design-system/Amount';
import { hitSlopS, IconArrow, rem, Spacer } from 'design-system';
import IconTooltip from 'design-system/icons/IconTooltip';
import IconEmmaWallet from 'design-system/icons/IconEmmaWallet';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import ToolTip from 'design-system/ToolTip';
import { selectTradingAccountFromId } from '../reducers/selectors';
import AvailableModal, { AVAILABLE_TITLE, getAvailableExplanation } from './AvailableModal';
import { isWeb } from '../../../constants';
const CashRow = ({ tradingAccountId, onPress, isPickerModalOpen }) => {
    const styles = useStyles(styleSet);
    const tradingAccount = useAppSelector((state) => selectTradingAccountFromId(state, tradingAccountId));
    const onInfoButtonPress = useCallback(() => {
        Keyboard.dismiss();
        AvailableModal.show(tradingAccountId);
    }, [tradingAccountId]);
    const disabled = !onPress;
    return (<TouchableBounceCard onDark disabled={disabled} noMarginTop noMarginBottom style={styles.cardBtn} onPress={onPress}>
      <View style={styles.row}>
        <IconEmmaWallet />
        <Spacer w={16}/>
        <View style={styles.flex}>
          <Text Text-16>Cash</Text>
          <View style={styles.row}>
            <Text TextThin-14 Secondary>
              Available{' '}
            </Text>
            {!!tradingAccount?.availableToInvest && (<Amount NumbersThin-14 Secondary value={tradingAccount.availableToInvest}/>)}
            <Spacer w={4}/>
            {isWeb ? (
        // On web the explanation shows on hover, like other info icons
        <ToolTip small colorKey="secondary" title={AVAILABLE_TITLE} subtitle={getAvailableExplanation(tradingAccount?.accountType)}/>) : (<TouchableOpacity onPress={onInfoButtonPress} hitSlop={hitSlopS}>
                <IconTooltip colorKey="secondary" width={16} height={16}/>
              </TouchableOpacity>)}
          </View>
        </View>
        {!disabled && (<View style={styles.arrow}>
            <IconArrow direction={isPickerModalOpen ? 'up' : 'down'}/>
          </View>)}
      </View>
    </TouchableBounceCard>);
};
const styleSet = createStyleSheets(() => ({
    cardBtn: {
        paddingVertical: rem(24),
        paddingHorizontal: rem(16),
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    flex: {
        flex: 1,
    },
    arrow: {
        width: rem(10),
        marginLeft: rem(16),
    },
}));
export default memo(CashRow);
